import React, { useState } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Grid, Box } from '@mui/material';
import { DateRangePicker as MuiDateRangePicker } from 'react-date-range';
import { useTranslation } from 'react-i18next';
import { EventIcon } from 'components/elements';
import moment from 'moment-timezone';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function DateRangePicker({ onChange, dateRange }) {
  const { t } = useTranslation('labels');
  const classes = useStyles();
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const handleSelect = (range) => {
    onChange(range);
  };

  return (
    <Box>
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={10} className={classes.dateTextParent}>
          {dateRange.startDate === undefined ? (
            <Typography variant="p" component="p">
              {t('select_a_date_range')}
            </Typography>
          ) : (
            <>
              <Typography variant="p" component="p">
                {moment(dateRange.startDate).format('ll')}
              </Typography>
              <Typography variant="p" component="p">
                -
              </Typography>
              <Typography variant="p" component="p">
                {moment(dateRange.endDate).format('ll')}
              </Typography>
            </>
          )}
        </Grid>
        <Grid item xs={2} onClick={() => setDateRangePicker(!dateRangePicker)} className={classes.dateIcon}>
          <EventIcon />
        </Grid>
      </Grid>
      {dateRangePicker && <MuiDateRangePicker ranges={[dateRange]} onChange={handleSelect} />}
    </Box>
  );
}

DateRangePicker.propTypes = {
  onChange: PropTypes.any.isRequired,
  dateRange: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DateRangePicker;
